import React from 'react';
import '../../Styles/theme/blockchain_window.css';

const BlockchainViewerModal = ({
  visible,
  tx_block_number,
  tx_paction_no,
  tx_place_no,
  tx_company_no,
  tx_block_hash,
  tx_TransactionHash,
  tx_raw_data,
  tx_event_type,
  tx_share_id,
  tx_open_id,
  tx_pdf_hash,
  onClose
}) => {
  if (!visible) return null;

  const splitStringWithBrackets = (str, maxLength) => {
    if (!str) return null;
    
    const chunks = [];
    let start = 0;
    while (start < str.length) {
      const end = start + maxLength;
      chunks.push(`[${str.slice(start, end)}]`);
      start = end;
    }
    return chunks.map((chunk, index) => (
      <React.Fragment key={index}>
        {chunk}
        <br />
      </React.Fragment>
    ));
  };

  return (
    <div className="overlay_blockchain">
      <div className="modal_blockchain" onClick={(e) => e.stopPropagation()}>
        <div className="header_blockchain">
          <span className="title_blockchain">鏈上資訊瀏覽器</span>
        </div>
        <div className="body_blockchain">
          <div className="left-column">
            <div className="row_blockchain">
              <span className="label_blockchain">區塊號碼:</span>
              <br />
              <span className="value_blockchain">{tx_block_number}</span>
            </div>
            {tx_event_type && (
              <div className="row_blockchain">
                <span className="label_blockchain">事件類別:</span>
                <br />
                <span className="value_blockchain">{tx_event_type}</span>
              </div>
            )}
            {tx_share_id !== undefined && tx_share_id !== null && (
              <div className="row_blockchain">
                <span className="label_blockchain">分享識別 (share_id):</span>
                <br />
                <span className="value_blockchain">{tx_share_id}</span>
              </div>
            )}
            {tx_open_id !== undefined && tx_open_id !== null && (
              <div className="row_blockchain">
                <span className="label_blockchain">開啟識別 (open_id):</span>
                <br />
                <span className="value_blockchain">{tx_open_id}</span>
              </div>
            )}
            <div className="row_blockchain">
              <span className="label_blockchain">證書編號:</span>
              <br />
              <span className="value_blockchain">{tx_paction_no}</span>
            </div>
            <div className="row_blockchain">
              <span className="label_blockchain">運作場所管編:</span>
              <br />
              <span className="value_blockchain">{tx_place_no}</span>
            </div>
            <div className="row_blockchain">
              <span className="label_blockchain">運作人管編:</span>
              <br />
              <span className="value_blockchain">{tx_company_no}</span>
            </div>
          </div>
          <div className="right-column">
            {tx_pdf_hash && (
              <div className="row_blockchain">
                <span className="label_blockchain">證件 PDF Hash (SHA-256):</span>
                <br />
                <span className="value_blockHash_Tx_blockchain">{tx_pdf_hash}</span>
              </div>
            )}
            <div className="row_blockchain">
              <span className="label_blockchain">區塊 hash 值:</span>
              <br />
              <span className="value_blockHash_Tx_blockchain">{tx_block_hash}</span>
            </div>
            <div className="row_blockchain">
              <span className="label_blockchain">鏈上 Tx:</span>
              <br />
              <span className="value_blockHash_Tx_blockchain">{tx_TransactionHash}</span>
            </div>
            <div className="row_blockchain">
              <span className="label_blockchain">16進位值:</span>
              <div className="value_hexRawData_blockchain raw-data_blockchain">
                {splitStringWithBrackets(tx_raw_data, 50)}
              </div>
            </div>
          </div>
        </div>
        <div className="footer_blockchain">
          <button className="exit-button_blockchain" onClick={(e) => { e.stopPropagation(); onClose(); }}>離開瀏覽器</button>
        </div>
      </div>
    </div>
  );
};

export default BlockchainViewerModal;
